const StudentCabinetMetrics = Object.freeze({
    BreadcrumbsToMainPage: 'BreadcrumbsToMainPage',
    StudentCabinetUserManual: 'StudentCabinetUserManual',
    LinkToWebinar: 'LinkToWebinar',
    UploadByCode: 'UploadByCode',
    UploadByCodeManual: 'UploadByCodeManual',
    UploadByCodeChangeTitle: 'UploadByCodeChangeTitle',
    UploadByCodeContinue: 'UploadByCodeContinue',
    UploadByCodeCancel: 'UploadByCodeCancel',
    UploadByTask: 'UploadByTask',
    UploadByTaskManual: 'UploadByTaskManual',
    UploadByTaskContinue: 'UploadByTaskContinue',
    UploadByTaskCancel: 'UploadByTaskCancel',
    ActiveCourses: 'ActiveCourses',
    ArchiveCourses: 'ArchiveCourses',
    Reference: 'Reference',
    ReferenceGenerate: 'ReferenceGenerate',
    ReferenceCancel: 'ReferenceCancel',
    LinkToReadVersion: 'LinkToReadVersion',
    Show10: 'Show10',
    Show20: 'Show20',
    Show50: 'Show50',
    Show100: 'Show100',
    GoToThePage: 'GoToThePage',
    GoToTheNextPage: 'GoToTheNextPage',
    GoToTheLastPage: 'GoToTheLastPage',
    GoToTheFirstPage: 'GoToTheFirstPage',
    GoToThePreviousPage: 'GoToThePreviousPage',
    LinkToCheckResults: 'LinkToCheckResults'
})

export default StudentCabinetMetrics